module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDkgMTIiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik05IDZMMi4wNDA4NmUtMDYgMTEuMTk2MkwxLjkxNjkzZS0wNiAwLjgwMzg0OEw5IDZaIiBmaWxsPSIjRjZEOUFBIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/triangle.svg
// module id = SnNW
// module chunks = 1